<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="performingRequest"
      :can-cancel="true"
    ></b-loading>
    <!-- Posts Listing -->
    <section>
      <h3 class="title-left-border">Usuários</h3>
      <hr>
      <b-collapse
        :open="true"
        position="is-bottom"
        aria-id="contentIdForA11y1"
      >
        <div class="mb-8 columns">
          <ValidationObserver
            ref="profileFormObserver"
            tag="form"
            @submit.prevent="validateBeforeSubmit()"
            class="columns column is-multiline is-12"
          >
            <!-- Nome -->
            <validation-provider
              rules="alpha_spaces"
              v-slot="{ errors }"
              name="Nome"
              class="column min-300"
            >
              <b-field
                label="Nome"
                :type="{'is-danger': errors[0]}"
                :message="errors[0]"
              >
                <b-input
                  v-model="search.name"
                  placeholder="Nome"
                />
              </b-field>
            </validation-provider>

            <!-- Sobrenome -->

            <validation-provider
              rules="alpha_spaces"
              v-slot="{ errors }"
              name="lastname"
              class="column min-300"
            >
              <b-field
                label="Sobrenome"
                :type="{'is-danger': errors[0]}"
                :message="errors[0]"
              >
                <b-input
                  v-model="search.lastName"
                  placeholder="Sobrenome"
                />
              </b-field>
            </validation-provider>

            <!-- Email -->

            <validation-provider
              rules="email"
              v-slot="{ errors }"
              name="Email"
              class="column min-300"
            >
              <b-field
                label="Email"
                :type="{'is-danger': errors[0]}"
                :message="errors[0]"
              >
                <b-input
                  v-model="search.email"
                  placeholder="Email"
                />
              </b-field>
            </validation-provider>

            <!-- Tipo de Usuário -->

            <b-field
              label="Tipo"
              class="column max-150"
            >
              <b-select
                placeholder="Tipo de Usuário"
                v-model="search.userType"
              >
                <option value="patient">
                  Cliente
                </option>
                <option value="professional">
                  Profissional
                </option>
                <option
                  value="all"
                  selected
                >
                  Todos
                </option>
              </b-select>
            </b-field>

            <!-- Premium -->
            <b-field
              label="Premium"
              class="column max-150"
            >
              <b-select
                placeholder="Premium ?"
                v-model="search.isPremium"
              >
                <option :value="true">
                  Sim
                </option>
                <option :value="false">
                  Não
                </option>
                <option
                  value="all"
                  selected
                >
                  Todos
                </option>
              </b-select>
            </b-field>

            <span class="column is-12">
              <b-button
                class="mr-4"
                type="is-primary"
                native-type="submit"
              >
                Pesquisar/Atualizar
              </b-button>
            </span>
          </ValidationObserver>
        </div>
        <a
          slot="trigger"
          slot-scope="props"
          aria-controls="contentIdForA11y1"
        >
          <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'"></b-icon>
          {{ !props.open ? 'Expandir' : 'Recolher' }}

        </a>

        <!-- Paginated Table -->

        <div v-if="users.length">
          <b-table
            :data="users"
            :paginated="true"
            :per-page="perPage"
            :total="total"
            :current-page.sync="currentPage"
            :pagination-simple="false"
            default-sort="user.name"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >

            <template slot-scope="props">
              <!-- Name -->
              <b-table-column
                field="name"
                label="Nome"
                sortable
                searchable
              >
                {{ props.row.name }}
              </b-table-column>

              <!-- Last Name -->
              <b-table-column
                field="lastName"
                label="Sobrenome"
                sortable
                searchable
              >
                {{ props.row.lastName }}
              </b-table-column>
              <!-- Email -->
              <b-table-column
                field="email"
                label="Email"
                sortable
                searchable
              >
                {{ props.row.email }}
              </b-table-column>

              <!-- Type -->
              <b-table-column
                field="userType"
                label="Tipo"
                sortable
              >
                {{ props.row.userType == 'patient' ? 'Cliente' : 'Profissional' }}
              </b-table-column>

              <!-- Premium -->
              <b-table-column
                field="isPremium"
                label="Premium"
                sortable
              >
                {{ props.row.isPremium ? 'Sim' : 'Não' }}
              </b-table-column>

              <!-- Actions -->
              <b-table-column
                fields="id"
                label="Ações"
                width="150"
              >
                <b-button
                  type="is-danger"
                  @click="confirmRemoveUser(props.row)"
                  class="mr-2"
                >
                  <b-tooltip label="Apagar">
                    <b-icon icon="delete" />
                  </b-tooltip>
                </b-button>
                <b-button @click="setSelectedUser(props.row)">
                  <b-tooltip label="Editar">
                    <b-icon icon="square-edit-outline" />
                  </b-tooltip>
                </b-button>

              </b-table-column>

            </template>
          </b-table>
        </div>
        <div
          v-else
          class="text-center"
        >
          <h3>Nenhum Resultado Disponível</h3>
        </div>

        <!--- Paginated Table End -->
      </b-collapse>
    </section>
    <b-modal
      has-modal-card
      :active.sync="isUserEditModalOpen"
      trap-focus
      aria-role="dialog"
      aria-modal
      :parent="this"
    >
      <UserEditModal :userData="selectedUser"></UserEditModal>
    </b-modal>

  </div>
</template>

<script>
import { usersCollection, professionalsGeoCollection, functions } from '../../firebaseConfig'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import UserEditModal from './UserEditModal'
import { mapState } from 'vuex'

export default {
  components: {
    UserEditModal,
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      search: {
        name: '',
        lastName: '',
        email: '',
        userType: 'all',
        isPremium: 'all'
      },
      selectedUser: {},
      isUserEditModalOpen: false,
      lastQueried: null,
      currentPage: 1,
      perPage: 5,
      total: 0,
      performingRequest: false
    }
  },

  computed: {
    ...mapState(['users'])
  },

  methods: {
    setSelectedUser (userData) {
      this.selectedUser = userData
      this.isUserEditModalOpen = true
    },
    async validateBeforeSubmit () {
      const isValid = await this.$refs.profileFormObserver.validate()

      if (isValid) {
        this.searchUsers()
      } else {
        console.log('inválido')
      }
    },
    async searchUsers () {
      try {
        this.performingRequest = true

        await this.$store.dispatch('fetchUsers', this.search)

        this.total = this.$store.state.users.length
      } catch (error) {
        console.error(error)
      } finally {
        this.performingRequest = false
      }
    },

    confirmRemoveUser (user) {
      this.$buefy.dialog.confirm({
        message: 'Tem certeza que deseja remover este usuário? Esta ação não poderá ser desfeita.',
        title: 'Remoção de usuário',
        confirmText: 'Remover',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.removeUser(user)
      })
    },

    async removeUser (user) {
      try {
        this.performingRequest = true
        if (user.userType === 'professional') {
          await professionalsGeoCollection.doc(user.id).delete()
        }
        await usersCollection.doc(user.id).delete()
        await functions.httpsCallable('')
        this.$toasted.success('Usuário removido com sucesso')
        await this.$store.dispatch('fetchUsers', this.search)
      } catch (error) {
        this.$toasted.error('Não foi possível remover este usuário. Tente novamente mais tarde')
      } finally {
        this.performingRequest = false
      }
    }

  }

}
</script>
<style scoped>
.modal section {
  margin: unset !important;
}
.modal-background {
  background-color: rgba(10, 10, 10, 0.25) !important;
}
</style>
